import { render, staticRenderFns } from "./recomendDoctor.vue?vue&type=template&id=5dbcde4d&"
import script from "./recomendDoctor.vue?vue&type=script&lang=js&"
export * from "./recomendDoctor.vue?vue&type=script&lang=js&"
import style0 from "./recomendDoctor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./recomendDoctor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports